import { Tooltip } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import PullToRefresh from 'react-simple-pull-to-refresh';
import { LoadSettings, UpdateMenuFlag, UpdateSettings } from "../../actions/index";
import Config from "../../config";
import { setHeaderTitle } from "../../helpers/header.helper";
import setToast from "../../helpers/toaster.helper";
import { InformationDarkScheduleIcon, ChannelSettingsGeneralIcon, ChannelSettingsGeneralActiveIcon, ChannelSettingsBusinessHoursActiveIcon, ChannelSettingsBusinessHoursIcon, ChannelSettingsNotificationsIcon, ChannelSettingsNotificationsActiveIcon, ChannelSettingsCustomSignatureIcon, ChannelSettingsCustomSignatureActiveIcon, BurgerMenuIcon, } from "../../icon";
import { ProfileModel } from "../../models/profile.model";
import { Setting, mapToTimeZoneModel } from "../../models/settings-model";
import * as selector from '../../selectors/selectors';
import { SettingsService } from "../../services/SettingsService";
import { UserService } from "../../services/UserService";
import ConfirmDialog from "../shared/confirm-dialog.component";
import { ActionLabels, ToasterTexts, ViewTextLabels, appNote, pageTitles, } from "../shared/constants";
import CustomSwitch from "../shared/switch.component";
import { ToasterType } from "../shared/toaster/toaster.model";
import { ChannelUserService } from "../../services/ChannelUserService";
import TimeZone from "./channel-time-zone.component";
import Signature from "./channel-signature.component";
import BusinessHoursComponent from "./business-hours.component";
import { ChannelAiService } from "../../services/channels/ChannelAiService";
import { updateAiFeaturesOrgLevel } from "../../reducers/reducer";
import { ChannelPlanModel, ChannelPlanStatus } from "../../models/users.model";



const SettingsComponent = () => {
    const dispatch = useDispatch();
    const IsMobileDevice: boolean = useSelector(selector.isMobileDevice)
    const IsTeamsApp: boolean = useSelector(selector.isTeamsApp)
    const Profile: ProfileModel = UserService.getCurrentUserFromLocalStorage()
    const Settings: Setting[] = useSelector(selector.settings)
    const AiFeatures: boolean = useSelector(selector.AiFeatures)
    const [isactiveBlock, setIsactiveBlock] = useState<boolean>(false);
    const [dialogTitle, setDialogTitle] = useState<string>("Settings");
    const [allChecked, setAllChecked] = useState<boolean>(false);
    const [Count, setCount] = useState<number>(0);
    const [showDialogue, setShowDialogue] = useState<boolean>(false);
    const [text, setText] = useState<string>("");
    const [switchType, setSwitchType] = useState<string>("");
    const [CheckedContacts, setCheckedContacts] = useState<any>([]);
    const [width, setWidth] = useState(window.innerWidth);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [ButtonName, setButtonName] = useState<string>("");
    const [showTime, setShowTime] = useState<boolean>()
    const [showSignature, setShowSignature] = useState<boolean>()
    const [showUnsubscribe, setShowUnsubscribe] = useState<boolean>()
    const [twoFactor, setTwoFactor] = useState<boolean>()
    const [settingOptionHovered, setSettingOptionHovered] = useState<string>("")
    const PlanDetails: ChannelPlanModel = useSelector(selector.PlanDetails);


    const [settingOptions, setSettingOptions] = useState([{ Name: "General", Icon: ChannelSettingsGeneralIcon, Selected: true, activeIcon: ChannelSettingsGeneralActiveIcon },
    { Name: "Business Hours", Icon: ChannelSettingsBusinessHoursIcon, Selected: false, activeIcon: ChannelSettingsBusinessHoursActiveIcon },
    { Name: "Notifications", Icon: ChannelSettingsNotificationsIcon, Selected: false, activeIcon: ChannelSettingsNotificationsActiveIcon },
    { Name: "Custom Signature", Icon: ChannelSettingsCustomSignatureIcon, Selected: false, activeIcon: ChannelSettingsCustomSignatureActiveIcon },
    ])

    useEffect(() => {
        setHeaderTitle(pageTitles.SETTINGS);
    }, [])

    const currentuser = JSON.parse(localStorage.getItem("current-user"));

    const closeConfirmDialog = (isConfirm: boolean) => {
        let btnLabel = ButtonName;
        if (switchType === "notification") {
            if (isConfirm) {
                setShowDialogue(false)
                setIsLoading(true)

                ChannelUserService.handleNotifcation(currentuser?.id, currentuser?.web_notification ? "disable" : "enable").then(() => {
                    currentuser.web_notification = !currentuser?.web_notification
                    localStorage.setItem('current-user', JSON.stringify(currentuser))
                    setIsLoading(false)
                }).catch(() => {
                    setIsLoading(false)
                })
            }
            else {
                setShowDialogue(false)
            }
        }
        else if (switchType === "email notification") {
            if (isConfirm) {
                setShowDialogue(false)
                setIsLoading(true)

                ChannelUserService.handleEmailNotifcation(currentuser?.organization_id, !currentuser?.email_notification).then(() => {
                    currentuser.email_notification = !currentuser?.email_notification
                    localStorage.setItem('current-user', JSON.stringify(currentuser))
                    setIsLoading(false)
                }).catch(() => {
                    setIsLoading(false)
                })
            }
            else {
                setShowDialogue(false)
            }
        }
        else if (switchType === "falkon-ai") {
            if (isConfirm) {
                const value = !AiFeatures
                setShowDialogue(false)
                setIsLoading(true)
                ChannelAiService.UpdateAiFeaturesAvailableStatus(ChannelUserService.getCurrentUserFromLocalStorage().OrganizationID, value.toString()).then(() => {
                    dispatch(updateAiFeaturesOrgLevel(value))
                    setIsLoading(false)
                    setToast(btnLabel === ActionLabels.ENABLE ? ToasterTexts.FALKON_CHAT_AI_ENABLE_SUCCESS : ToasterTexts.FALKON_CHAT_AI_DISABLE_SUCCESS, ToasterType.SUCCESS);
                }).catch((err) => {
                    setIsLoading(false)
                })
            }
            else {
                setShowDialogue(false)
            }
        }
        else if (switchType === SettingsService.Notification_Code) {
            if (isConfirm) {
                setShowDialogue(false)
                setIsLoading(true)
                let setting = Settings.find(
                    (x) => x.Code === SettingsService.Notification_Code
                );
                if (setting) {
                    UpdateSettings(dispatch, {
                        id: setting?.ID,
                        name: setting?.Name,
                        code: setting?.Code,
                        value: btnLabel === ActionLabels.ENABLE ? "true" : "false",
                    });
                    setToast(
                        btnLabel === ActionLabels.ENABLE
                            ? ToasterTexts.NOTIFICATION_ON
                            : ToasterTexts.NOTIFICATION_OFF,
                        ToasterType.SUCCESS
                    );
                }
            } else {
                setShowDialogue(false)
                setIsLoading(false)
                setText("")
            }
        } else if (switchType === SettingsService.Voice_Otp_Veification) {
            if (isConfirm) {
                setShowDialogue(false)
                setIsLoading(true)
                let setting = Settings.find(
                    (x) => x.Code === SettingsService.Voice_Otp_Veification
                );
                if (setting) {
                    UpdateSettings(dispatch, {
                        id: setting?.ID,
                        name: setting?.Name,
                        code: setting?.Code,
                        value: btnLabel === ActionLabels.ENABLE ? "true" : "false",
                    });
                    setToast(
                        btnLabel === ActionLabels.ENABLE
                            ? ToasterTexts.VOICE_VERIFICATION_ON
                            : ToasterTexts.VOICE_VERIFICATION_OFF,
                        ToasterType.SUCCESS
                    );
                }
            } else {
                setShowDialogue(false)
                setIsLoading(false)
            }
        } else {
            if (isConfirm) {
                setShowDialogue(false)
                setIsLoading(true)
                let setting = Settings.find(
                    (x) => x.Code === SettingsService.Two_FactAuth_Code
                );
                let OrgName = Profile?.OrganizationName;
                UpdateSettings(dispatch, {
                    id: setting?.ID,
                    name: setting?.Name,
                    code: setting?.Code,
                    value: btnLabel === ActionLabels.ENABLE ? "true" : "false",
                });
                setToast(
                    btnLabel === ActionLabels.ENABLE
                        ? ToasterTexts.ORG_TWO_FACTOR_AUTH_ON.replace("<Name>", OrgName)
                        : ToasterTexts.ORG_TWO_FACTOR_AUTH_OFF.replace("<Name>", OrgName),
                    ToasterType.SUCCESS
                );
            } else {
                setShowDialogue(false)
                setIsLoading(false)
                setTwoFactor(false)
            }
        }
    };


    const openChannelConfirmDialog = (checked: boolean, type: string, text: string) => {
        setShowDialogue(true)
        setText(text)
        setButtonName(checked ? ActionLabels.ENABLE : ActionLabels.DISABLE)
        setSwitchType(type)
        setIsLoading(false)
    }

    const trimTimeZone = (time: any, chars: number) => {
        let label = `(${time.OffsetLabel}) ${time.Name}`
        return !!label ? label.slice(0, chars) + (label.length > chars ? "..." : "") : "";
    }

    const pullToRefresh = () => new Promise((resolve) => setTimeout(resolve, 15)).then(() => LoadSettings(dispatch));



    const handleOptionSelection = (option) => {
        setSettingOptions(settingOptions.map(x => x.Name === option ? { ...x, Selected: true } : { ...x, Selected: false }))
    }

    const handleAiFeaturesEnable = (value) => {
        ChannelAiService.UpdateAiFeaturesAvailableStatus(ChannelUserService.getCurrentUserFromLocalStorage().OrganizationID, value.toString()).then(() => {
            dispatch(updateAiFeaturesOrgLevel(value))
        })
    }

    return (
        <>
            <PullToRefresh isPullable={IsMobileDevice} pullingContent='' onRefresh={pullToRefresh} className='h-auto'>
                <div className="w-p-100 h-p-100">
                    {IsMobileDevice && <div className="d-flex h-p-8 align-center">
                        <span className={`ml-1`}>
                            <BurgerMenuIcon className="mr-1" onClick={(e) => { e.stopPropagation(); UpdateMenuFlag(dispatch, true) }} />
                        </span>
                        <span className="my-auto h1">
                            Settings
                        </span>
                    </div>
                    }
                    <div className={`${IsMobileDevice ? "h-p-92" : "h-p-100"} w-p-100  d-flex justify-center o-y-scroll`}>
                        <div className={`w-p-96 bg-color-secondary br-2 d-flex flex-direction ${IsMobileDevice ? "" : "mt-2"}`}>
                            <div className=" w-p-100 d-flex align-center">
                                <div className=" d-flex bg-color-channel-background br-2 py-1 d-flex align-center flex-wrap">
                                    {
                                        settingOptions.map(x => {
                                            return (
                                                <div className={`px-2 h-5 d-flex align-center h5-medium br-2 c-pointer ${x.Selected && "select-channel-active-border bg-color-secondary"} ${(settingOptionHovered === x.Name || x.Selected) && "color-primary-light"} ${IsMobileDevice ? "w-p-40" : ""}`} onMouseEnter={() => setSettingOptionHovered(x.Name)} onMouseLeave={() => setSettingOptionHovered("")} onClick={() => handleOptionSelection(x.Name)}>
                                                    {(settingOptionHovered === x.Name || x.Selected) ? <x.activeIcon className="mr-1" /> : <x.Icon className="mr-1" />} {x.Name}
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            </div>
                            <div className="d-flex flex-direction align-center py-2 w-p-100 settings-border mt-2 br-2 mb-8">
                                <div className="w-p-96 h-4 h3-medium d-flex align-center mx-auto">
                                    {settingOptions.find(x => x.Selected).Name}
                                </div>

                                {settingOptions.find(x => x.Selected).Name === "General" ?
                                    <>
                                        <div className="w-p-96 h-4 d-flex justify-between">
                                            <div className="h5-regular settings-nav-bar-option"> your account details</div>
                                            <div className="h4-medium color-primary-btn">
                                                {ViewTextLabels.VERSION}
                                                <span className="h5-medium ml-1">{Config.VERSION}</span></div>
                                        </div>
                                        <TimeZone />
                                        {!!PlanDetails.FeatureKeys.find(x => x === "falkon-ai") && (PlanDetails.Status === ChannelPlanStatus.ACTIVE || PlanDetails.Status === ChannelPlanStatus.TRAIL) &&
                                            < div className="w-p-96 d-flex flex-direction mx-auto mt-2 br-3">
                                                <div className='w-p-100 min-h-6 d-flex justify-between align-center'>
                                                    <div className="h5-medium pl-2">Falkon Chat AI</div>
                                                    <div className="h5-medium pr-2 d-flex align-center">
                                                        {/* <span className='pr-2'>Set Timezone automatically</span> */}
                                                        <CustomSwitch
                                                            checked={AiFeatures}
                                                            onChange={(checked: boolean) => openChannelConfirmDialog(checked, "falkon-ai", `Are you sure you want to ${checked ? "enable" : "disable"} Falkon Chat AI?`)}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                    </> :
                                    settingOptions.find(x => x.Selected).Name === "Business Hours" ?

                                        <>
                                            <div className="w-p-96 h-4 d-flex justify-between mx-auto">
                                                <div className="h5-regular settings-nav-bar-option"> Select on times your business operates</div>
                                                <div className="h4-medium settings-nav-bar-option">
                                                    <span className="h5-medium ml-1">{trimTimeZone(mapToTimeZoneModel(ChannelUserService.getCurrentUserFromLocalStorage()?.Timezone.SelectedTimeZone), 30)}</span></div>
                                            </div>
                                            <div className="w-p-96 mt-2">
                                                <BusinessHoursComponent />
                                            </div>
                                        </>
                                        :
                                        settingOptions.find(x => x.Selected).Name === "Notifications" ?
                                            <>
                                                <div className="w-p-96 h-4 d-flex justify-between mx-auto">
                                                    <div className="h5-regular settings-nav-bar-option"> Manage all you application's notifications</div>
                                                    <div className="h5-medium color-primary-btn"></div>
                                                </div>
                                                {!ChannelUserService.hasSysAdminRole() &&
                                                    <div className="w-p-96 min-h-6 d-flex justify-between align-center mx-auto br-3">
                                                        <div className="h5-medium"> Web Notifications</div>
                                                        <div className="h5-medium color-primary-btn">
                                                            {IsTeamsApp ? <CustomSwitch
                                                                checked={false}
                                                                disabled={true}
                                                                onChange={() => { }}
                                                            /> :
                                                                <CustomSwitch
                                                                    checked={currentuser?.web_notification}
                                                                    onChange={(checked: boolean) => openChannelConfirmDialog(checked, "notification", checked ? appNote.NOTIFICATION_ENABLE_MESSAGE : appNote.NOTIFICATION_DISABLE_MESSAGE)}
                                                                />}
                                                        </div>
                                                    </div>
                                                }
                                                {
                                                    currentuser.roleId === 2 &&
                                                    <div className="w-p-96 min-h-6 d-flex justify-between align-center mx-auto br-3">
                                                        <div className="h5-medium d-flex justify-center align-center"> Email Notifications
                                                            <Tooltip title='All your team members will receive an email notification, when a visitor texts you in non-business hours' placement='top'>
                                                                <InformationDarkScheduleIcon className={"c-pointer ml-1"} />
                                                            </Tooltip>
                                                        </div>
                                                        <div className="h5-medium color-primary-btn">
                                                            <CustomSwitch
                                                                checked={currentuser?.email_notification}
                                                                onChange={(checked: boolean) => openChannelConfirmDialog(checked, "email notification", checked ? appNote.EMAIL_NOTIFICATION_ENABLE_MESSAGE : appNote.EMAIL_NOTIFICATION_DISABLE_MESSAGE)}
                                                            />
                                                        </div>
                                                    </div>
                                                }
                                            </>
                                            :
                                            <>
                                                <Signature />
                                            </>
                                }
                            </div>
                        </div>
                        <ConfirmDialog
                            onClose={closeConfirmDialog}
                            Show={showDialogue}
                            Text={text}
                            ButtonName={ButtonName}
                            Loading={isLoading}
                            IsMobileDevice={IsMobileDevice}
                        ></ConfirmDialog>
                    </div>
                </div>
            </PullToRefresh >
        </>
    );
}

export default SettingsComponent
